import removeTags from 'service_modules/utils/text-remove-tags';

const convert = (title = '', separator = '-') => {
  return removeTags(String(title)).replace(/ /g, separator);
};

export default convert;
